import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { encode } from 'punycode';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  user$: BehaviorSubject<Object>;

  constructor(private http: HttpClient) {
    this.user$ = new BehaviorSubject(null);
  }

  loadUser() {
    // console.log("users")
    this.http.get("/api/data/user").subscribe(
      (response: any) => {
        const userRtn = response;
        this.user$.next(userRtn);
      }, (error: any) => {
        
        // not valid - redirect to sign in - pass the path and query string encoded
        // so we can redirect to the correct place after the signin
        if (window.self === window.top) {
          window.location.href = "/signin?redirect=" + encodeURIComponent(window.location.pathname + window.location.search);
        } else {
          // in iframe
          window.addEventListener('message', this.messageHandler, false);
          const loginWindow = window.open('/loginRedirect', '_blank');
          loginWindow.window.focus();
        }
        
      }
    );
  }

  messageHandler = (event: any) => {
    if (event.origin === window.location.origin && event.data === 'login successfully') {
      window.removeEventListener('message', this.messageHandler, false);
      window.location.reload();
    }
  }
}
